import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { Button, Form } from 'reactstrap';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import DynamicForm from '../../../common/forms/DynamicForm';
import { PICKUP_SENDER_REMISSION_GUIDE_ITEM_COLUMNS } from '../../../../config/dynamicFormFields';

export const PickupManualSenderRemissionGuideForm = ({
  handleSubmit,
  loading,
  onCancel,
}) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <DynamicForm
          title="Encomiendas"
          name="cargoItems"
          columns={PICKUP_SENDER_REMISSION_GUIDE_ITEM_COLUMNS}
          showAddButton={false}
          showRemoveButton={false}
        />

        <FormFooter
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
        >
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

PickupManualSenderRemissionGuideForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const selector = formValueSelector('PickupManualSenderRemissionGuideForm');

const mapStateToProps = (state) => ({
  loading: !state.CargoUnit.ManualSenderRemissionGuide.getIn([
    'current',
    'activity',
  ]).isEmpty(),
  globalReturnDate: selector(state, 'returnDate'),
  globalStatus: selector(state, 'senderRemissionGuideStatus'),
  globalComment: selector(state, 'comment'),
  cargoItems: selector(state, 'cargoItems'),
});

const formComponent = reduxForm({
  form: 'PickupManualSenderRemissionGuideForm',
})(PickupManualSenderRemissionGuideForm);

export default connect(mapStateToProps, null)(formComponent);
